module.exports = __webpack_public_path__ + "static/tr-1-6446fbf85dce2e829c0176e0a89aa3bf.png";